module.exports = __webpack_public_path__ + "static/media/CreacionUsuario.534ee56d.png";